import { unsafeSetDeepProp } from '@ipfabric/utils/fp/usafeSetDeepProp';
import {
  AUTO_SIZED_COLUMNS_DEFAULT,
  type TableCommandFactory,
} from 'components/Table/model/TableModel';
import { getFilteredColumnMinWidth } from './helpers/getFilteredColumnMinWidth';
import { requestAutoSize } from './requestAutoSize';

interface AdjustColumnWidthsForFilterCommand {
  // command need to know if simple field is filled, but at this moment the state is not updated yet
  // so we need to pass columnKeys to command to let him know what fields are filled and what fileds
  // have to be adjusted
  columnKeys: string[];
}

export const adjustColumnWidthsForFilter: TableCommandFactory<
  AdjustColumnWidthsForFilterCommand
> = (cmdContext, dispose) => async (command) => {
  const state = cmdContext.getState();

  if (state.settings.autoSizedColumns ?? AUTO_SIZED_COLUMNS_DEFAULT) {
    dispose(requestAutoSize);
  } else {
    cmdContext.updateState((draft) => {
      for (const columnKey of command.columnKeys) {
        const filter = state.simpleFilterFields?.[columnKey];
        const minWidth = getFilteredColumnMinWidth(filter?.filter);
        unsafeSetDeepProp(
          draft,
          'settings',
          'columnWidth',
          columnKey,
        )(Math.max(draft.settings.columnWidth?.[columnKey] ?? 0, minWidth));
      }
    });
  }
};
